var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossChainLabsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "256px",
    viewBox: "0 0 192 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-291.000000, 0.000000)",
    fill: "#69A1A0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "398 -2.22877272e-14 483 -9.52293799e-14 483 63 440.942619 63 440.942619 37.2092017 456.825506 37.2092017 456.825506 23.6650991 398 23.6650991"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "410 229.320134 411.263508 255.070715 482 256 481.557201 197 441.228547 198.532032 442.754559 214.008613 455.022696 214.7254 454.965773 228.343725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "344.378273 91 306 68.8416872 359.47923 1 394 34.1378951 382.993543 48.7095362 368.100648 33.4176023 345.136897 65.7158176 356.48572 75.4384931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3-Copy-2",
    points: "342 172 304.400029 172 291 92 340.735751 93.3668422 342 111.346687 320.99605 109.56815 325.830879 154.508108 340.735751 154.508108"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3-Copy",
    points: "353.767201 177 330 198.697396 368.828531 254 403 220.270925 389.843774 202.387133 380.199027 219.039932"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-3",
    points: "332.354242 113.300651 327 122.135436 356.309614 129 373 75.7827554 360.705819 72 348.161967 114.186718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-4",
    points: "368.603809 46.8292437 359 51.2460548 380.716955 73 425 37.8762007 416.395329 28 381.889965 56.2196761"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-5",
    points: "334.263635 151.281975 329 143.339005 355.53058 133 373 182.782881 361.908854 188 348.688948 148.450246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-14",
    transform: "translate(397.445675, 205.214300) rotate(-29.000000) translate(-397.445675, -205.214300) ",
    points: "380.689074 196.78791 375.416914 189.535907 401.964784 180.11495 419.474436 225.5585 408.376518 230.31365 395.12521 194.211623"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChainLabsLogo);
export default __webpack_public_path__ + "static/media/CrossChainLabsLogo.27c40c80f47876a2ade2c70d83f60e51.svg";
export { ForwardRef as ReactComponent };